// plugins/chat.js

export default ({ app, route }, inject) => {
  if (process.client) {
    const provider = process.env.CHAT_PROVIDER;

    const shouldShowChat = () => {
      return route.path.match(/^\/book\/[^\/]+\/[^\/]+\/[^\/]+$/) ||
        route.path.match(/^\/checkout\/\d+$/);
    };

    if (!shouldShowChat()) return;

    if (provider === 'chatwoot') {
      // Chatwoot
      (function (d, t) {
        const BASE_URL = "https://chatpeppertix-76116546948a.herokuapp.com";
        const g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = BASE_URL + "/packs/js/sdk.js";
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function () {
          window.chatwootSDK.run({
            websiteToken: 'hQwidvrwqipL8ZcAkm2BELPC',
            baseUrl: BASE_URL
          });
        };
      })(document, "script");
    }

    if (provider === 'crisp') {
      // Crisp
      (function () {
        const d = document;
        const s = d.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = 1;
        d.getElementsByTagName('head')[0].appendChild(s);
      })();

      window.$crisp = [];
      window.CRISP_WEBSITE_ID = '8a695e01-72f2-4ae4-bf85-80e6cec85c7b'; // Tu ID
    }
  }
};
